import type { SegmentedControlProps } from './SegmentedControl.types';

const pillBaseClasses =
  'sq-segmented-control-pill tw:cursor-pointer tw:rounded-full tw:border tw:px-3 tw:py-1.5 tw:text-sm tw:transition-all tw:duration-150 tw:ease-out tw:focus-visible:outline-none tw:focus-visible:ring-2 tw:focus-visible:ring-sq-theme-link/30 tw:focus-visible:ring-offset-1 tw:dark:focus-visible:ring-offset-sq-dark-background';

const pillInactiveClasses = 'sq-segmented-control-pill--inactive';

const pillActiveClasses = 'sq-segmented-control-pill--active';

function SegmentedControl<T extends string | number | boolean>({
  options,
  value,
  onChange,
  extraClassNames = '',
  id,
  testId,
  ariaLabel,
}: SegmentedControlProps<T>) {
  const containerClasses = `tw:flex tw:flex-wrap tw:gap-2 ${extraClassNames}`;

  return (
    <div aria-label={ariaLabel} className={containerClasses} data-testid={testId} id={id} role="group">
      {options.map((option) => {
        const isActive = option.value === value;
        const buttonClasses = `${pillBaseClasses} ${isActive ? pillActiveClasses : pillInactiveClasses}`;
        return (
          <button
            aria-pressed={isActive}
            className={buttonClasses}
            key={String(option.value)}
            onClick={onChange ? () => onChange(option.value) : undefined}
            type="button">
            {option.label}
          </button>
        );
      })}
    </div>
  );
}

export default SegmentedControl;
